import React from 'react';
import { Services } from 'services';
import { Box, Button, Image, Spinner, Text } from '@clariness/clarikit-react';
import genericErrorSrc from 'assets/images/generic-error.png';
import { FormattedMessage, useIntl } from 'react-intl';
import { usePatientDetailsContext } from '../../ReferralDetails';
import {
  PatientDetailsBasic,
  PatientDetailsContact,
  StudyDetails,
} from './components';

export const PatientDetailsProfile = () => {
  const intl = useIntl();
  const { currentReferral } = usePatientDetailsContext();

  const { referral, isLoading, isError, refetch } =
    Services.Referrals.useGetReferral(currentReferral?.id);
  const { Protocol801Participation, isLoading: isProtocol801Loading } =
    Services.Referrals.useUpdateProtocol801Participation({});

  if (isError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="28px"
        margin="auto"
      >
        <Image
          width="213px"
          src={genericErrorSrc}
          alt="Something went wrong illustration"
        />
        <Text as="p" variant="bodyLg" color="color-gray-variant-2">
          <FormattedMessage
            id="is.patient_details_modal.generic_error_message"
            defaultMessage="Something went wrong while we tried to display the patient's details."
          />
        </Text>
        <Button onClick={refetch}>
          {intl.formatMessage({
            id: 'is.generic_error.try_again_button',
            defaultMessage: 'Try again',
          })}
        </Button>
      </Box>
    );
  }

  return (
    <React.Fragment>
      {referral && (
        <Box
          display="flex"
          flexWrap="wrap"
          width="100%"
          height="fit-content"
          gap="48"
          style={{ overflow: isLoading ? 'hidden' : undefined }}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap="32"
            style={{ flex: '1 1 32rem', minWidth: 'min(100%, 32rem)' }}
          >
            <PatientDetailsBasic referral={referral} />
            <PatientDetailsContact referral={referral} />
          </Box>

          <Box
            display="flex"
            style={{ flex: '1 1 32rem', minWidth: 'min(100%, 32rem)' }}
          >
            <StudyDetails
              referral={referral}
              Protocol801Participation={Protocol801Participation}
              refetch={refetch}
            />
          </Box>
        </Box>
      )}

      {(isLoading || isProtocol801Loading) && (
        <Box
          data-testid="loader"
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
          backgroundColor="rgba(255, 255, 255, 0.6)"
          style={{ position: 'absolute', top: 0, left: 0 }}
        >
          <Spinner size="medium" colorVariant="green" />
        </Box>
      )}
    </React.Fragment>
  );
};
